<template>
  <header
    :class="[
      'header',
      { 'header--home': page === 'Home' },
      { active: openMenu },
      { 'header--hidden': !showNavbar },
      { 'header--white': topBlack }
    ]"
  >
    <div class="limit-grid">
      <div class="header__wrapper">
        <div class="header__logo">
          <router-link :to="{ name: 'Home' }">
            <img
              src="@/assets/logo.svg"
              alt="logo cartão de todos Clube do Bahia"
              class="header__logo--cdt header__logo--desk"
            />
            <img
              src="@/assets/logo-mobile.svg"
              alt="logo cartão de todos Clube do Bahia"
              class="header__logo--cdt header__logo--mobile"
            />
          </router-link>
        </div>
        <div class="header__mobile-btn">
          <img src="@/assets/icons/menu.svg" alt @click.prevent="toggleMenu" />
        </div>
        <div :class="['header__nav', { active: menu }]">
          <div class="header__nav__close">
            <img
              src="@/assets/icons/close.svg"
              alt="botão fechar"
              @click.prevent="toggleMenu"
            />
          </div>
          <ul class="header__menu">
            <li>
              <router-link :to="{ name: 'Contact' }">Contato</router-link>
            </li>
          </ul>
          <a
            href="https://vendas.cartaodetodosBahia.com.br/solicite"
            target="_blank"
            class="header__button"
            >Solicite seu Cartão</a
          >
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      page: null,
      lastScrollPosition: 0,
      showNavbar: true,
      openMenu: false,
      topBlack: false,
      menu: false
    };
  },
  methods: {
    onScroll() {
      if (window.pageYOffset < 0) {
        return;
      }
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < 130) {
        return;
      }

      if (window.pageYOffset > 150 && this.$route.name === "Home") {
        this.topBlack = true;
      } else {
        this.topBlack = false;
      }
      this.showNavbar = window.pageYOffset < this.lastScrollPosition;
      this.lastScrollPosition = window.pageYOffset;
    },
    toggleMenu() {
      this.menu = !this.menu;
    }
  },
  mounted() {
    this.lastScrollPosition = window.pageYOffset;
    window.addEventListener("scroll", this.onScroll);
  },
  created() {
    this.page = this.$route.name;
  }
};
</script>

<style lang="scss">
.header {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0px;
  width: 100%;
  justify-content: center;
  transform: translate3d(0, 0, 0);
  transition: 0.3s ease-in-out;
  padding: 20px 0;
  background: $color-primary;
  @include media(">=tablet") {
    &--hidden {
      transform: translate3d(0, -100%, 0);
    }
  }
  &--home {
    @include media(">=tablet") {
      background: transparent;
    }
  }
  &--white {
    background: $color-primary;
  }
  .router-link-exact-active {
    padding: 0 10px 10px;
    border-bottom: 8px solid $color-yellow;
  }
  &__wrapper {
    display: grid;
    grid-template-columns: auto max-content;
    align-items: center;
  }
  &__logo {
    a {
      border: none !important;
      padding: 0 !important;
    }
    &--desk {
      display: none;
      @include media(">=tablet") {
        display: block;
      }
    }
    &--mobile {
      display: block;
      @include media(">=tablet") {
        display: none;
      }
    }
    // &--cdt {
    //   max-width: 127px;
    //   @include media(">=tablet") {
    //     max-width: initial;
    //   }
    // }
    &--Bahia {
      max-width: 28px;
      @include media(">=tablet") {
        max-width: initial;
      }
      &:last-child {
        margin-left: 30px;
      }
    }
  }
  &__mobile-btn {
    display: block;
    @include media(">=tablet") {
      display: none;
    }
  }
  &__nav {
    justify-self: flex-end;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 102;
    background: $color-primary;
    width: calc(100vw - 74px);
    height: 100vh;
    margin-top: 0px;
    transform: translateX(calc(100% + 74px));
    transition: 0.3s ease-in-out;
    @include media(">=tablet") {
      position: initial;
      top: initial;
      right: initial;
      background: initial;
      width: initial;
      height: initial;
      transform: initial;
    }
    &::after {
      content: "";
      width: 74px;
      height: 100vh;
      position: fixed;
      top: 0;
      left: -74px;
      background: RGBA(0, 0, 0, 0.5);
      z-index: -1;
      display: block;
      @include media(">=tablet") {
        display: none;
      }
    }
    &.active {
      transform: translateX(0%);
    }
    &__close {
      text-align: right;
      margin-top: 30px;
      margin-right: 30px;
      display: block;
      @include media(">=tablet") {
        display: none;
      }
    }
  }
  &__menu {
    list-style: none;
    display: block;
    margin: 30% 0px;
    padding: 0px;
    margin-top: 25%;
    margin-bottom: 25%;
    @include media(">=tablet") {
      display: inline-flex;
      justify-content: flex-end;
      margin: 0px;
    }
    li {
      margin-bottom: 30px;
      text-align: center;
      @include media(">=tablet") {
        margin-right: 38px;
        margin-bottom: initial;
        text-align: initial;
      }
      &:last-child {
        margin-right: 0;
      }
    }

    a {
      text-decoration: none;
      font-size: 22px;
      font-weight: bold;
      transition: 0.3s ease-in-out;
      text-transform: uppercase;
      color: $color-yellow;
      @include media(">=tablet") {
        font-size: 14px;
        font-weight: 700;
        text-transform: initial;
        padding-bottom: 10px;
        color: $color-white;
        border-bottom: 0px solid $color-yellow;
        &:hover {
          border-bottom: 8px solid $color-yellow;
        }
      }
    }
  }
  &__button {
    display: block;
    max-width: 273px;
    margin: 0px auto;
    padding: 10px 26px;
    border-radius: 31px;
    background: $color-yellow;
    color: $color-gray;
    font-family: "Arvo", serif;
    font-weight: 700;
    font-size: 20px;
    text-decoration: none;
    border: 2px solid transparent;
    transition: 0.3s ease-in-out;
    text-align: center;

    @include media(">=tablet") {
      display: initial;
      margin: 0px 0px 0px 30px;
      background: $color-yellow;
      color: $color-black;
      &:hover {
        background: $color-black;
        color: $color-yellow;
        border-color: $color-yellow;
      }
    }
  }
}
</style>
